module.exports = __webpack_public_path__ + "e85a4a20fff4218f8789c2a56de5e06f.fbx";